var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"black ma-2",attrs:{"loading":_vm.isLoading,"outlined":"","dark":""},on:{"click":function($event){return _vm.syncSkpTriwulan()}}},[_c('v-icon',[_vm._v("mdi-sync")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }